// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationSection_root__HPnhK","description":"IntegrationSection_description__rDJt9","grid":"IntegrationSection_grid__DYEUX","gif":"IntegrationSection_gif__Co964"};